// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__Dx4iY","inputWrap":"CustomTip_inputWrap__3ygTH"};